import { Injectable } from '@angular/core';
import { filter, map } from 'rxjs/operators';
import { z } from 'zod';
import { IMessageSocketRepository } from 'src/app/core/chat/repository/message/message-socket-repository';
import { MessageEntity } from '../../entity/message';
import { getInstanceId } from 'src/app/module/chat/domain/chat-service.service';


export const ListenMessageByRoomIdNewInputDTOSchema = z.object({
  roomId: z.string(),
});
export type ListenMessageByRoomIdNewInputDTO = z.infer<typeof ListenMessageByRoomIdNewInputDTOSchema>


@Injectable({
  providedIn: 'root'
})
export class ListenMessageByRoomIdNewUseCase {

  constructor(
    private MessageSocketRepositoryService: IMessageSocketRepository
  ) { }

  execute(data: ListenMessageByRoomIdNewInputDTO) {

    return this.MessageSocketRepositoryService.listenToMessages().pipe(
      map(message => message.data),
      filter((message) =>  message?.deviceId != getInstanceId() && data.roomId == message?.roomId),
      map(message => {
        return Object.assign(new MessageEntity(), message)
      })
    )

  }
}
